<template>
    <div id="packer_current_pack">
        <div class="ui card">
            <div class="content">
                <h2 class="ui header">
                    <i class="info icon"></i>
                    <div class="content">
                        目前包裹
                    </div>
                </h2>
            </div>
            <div class="content">
                <table class="ui celled table">
                    <thead>
                        <tr>
                            <th class="six wide center aligned">欄位</th>
                            <th class="ten wide center aligned">內容</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="center aligned">號碼</td>
                            <td class="center aligned">{{ current_pack.core_waybill_number }}</td>
                        </tr>
                        <tr>
                            <td class="center aligned">親包號碼</td>
                            <td class="center aligned">
                                <span v-if="parent_pack">
                                    {{ parent_pack.core_waybill_number }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        current_pack: Object,
        parent_pack: Object
    },
    data: function() {
        return {
        }
    },
    computed: {
    },
    watch: {
    },
    created: function() {
    },
    mounted: function() {
    },
    methods: {
    },
    components: {
    }
}
</script>
